import { noop } from 'lodash';
import { HttpStatusCodes, ServerException } from '../../constants';
import { stringifyIdsFromBody } from '../utils/bodyIdTransform';
import { GA_EVENTS } from './constants';

const apiHost = process.env.API_HOST || '';
const getWellGuideRecommendationsEndpoint = `${apiHost}/api/patient/v1/well-guide-status`;

export function fetchWellGuideData(gaTrackEvent = noop) {
    gaTrackEvent(GA_EVENTS.fetchingWellGuideStatus);
    return fetch(getWellGuideRecommendationsEndpoint, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });
}

function getWellGuideDataResponse(gaTrackEvent) {
    return fetchWellGuideData(gaTrackEvent)
        .then(response => {
            if (response.status === HttpStatusCodes.OK) {
                gaTrackEvent(GA_EVENTS.fetchedWellGuideStatus);
                return response.json();
            } else if (response.status === HttpStatusCodes.Unauthorized) {
                gaTrackEvent(GA_EVENTS.failedFetchUnauthorized);
                return {
                    status: 'unauthorized',
                };
            } else {
                gaTrackEvent(GA_EVENTS.failedFetchError);
                throw new ServerException({ response });
            }
        });
}

export function getWellGuideData(gaTrackEvent = noop) {
    return getWellGuideDataResponse(gaTrackEvent)
        .then(body => {
            if (body.status === 'unauthorized') {
                return {
                    recommendations: [],
                    completedTasks: [],
                    incompleteTasks: [],
                    completedCount: 0,
                    totalCount: 0,
                    patient: null,
                };
            } else {
                const recommendations = body.recommendations.map(stringifyIdsFromBody);
                const completedTasks = recommendations.filter(x => x.is_complete);
                gaTrackEvent(GA_EVENTS.fetchedWellGuideStatus);
                return {
                    recommendations,
                    completedTasks,
                    incompleteTasks: recommendations.filter(x => !x.is_complete),
                    completedCount: completedTasks.length,
                    totalCount: recommendations.length ? recommendations.length : 5,
                    sawWellGuideOnboarding: body.saw_well_guide_onboarding,
                    patient: body.patient,
                };
            }
        })
        .catch(err => {
            if (err instanceof ServerException) {
                throw new Error(`Failed to fetch well guide status with response status ${err.response.status}`);
            } else {
                gaTrackEvent(GA_EVENTS.failedParseResponse);
                throw new Error(`Failed to parse well guide status response with error: ${err.message}`);
            }
        });
}
